import {useTrackFeature} from '@aboutyou/tracking';
import {useTrackBackButtonOriginClick} from './useOriginClickTracking';

export const useBackButtonTracking = () => {
  const trackFeature = useTrackFeature();
  const trackOriginClick = useTrackBackButtonOriginClick();

  return () => {
    trackFeature({eventType: 'click', label: 'backButton', name: 'backButton'});
    trackOriginClick();
  };
};
